import React from 'react';
import { Redirect, Route } from 'react-router-dom';


const PrivateCourse = ({ component: Component, ...rest }) => {

    const isAuthenticatedUser = localStorage.getItem("bearer_cogen_token")
    const hasCourseId = localStorage.getItem("courses_cogen_id")
    
    return (
        <Route
            {...rest}
            render={(props) => isAuthenticatedUser && hasCourseId ? <Component {...props} /> : <Redirect to="/login" />}
        />
    )
}
export default PrivateCourse